<template lang="pug">
  v-layout.column.fill-height(v-if="(object.has_idp_user || type === 'client') && Object.keys(computedRoles).length || !loaded" v-rc-loader="!loaded")
    v-flex.xs12.roles-wrapper
      v-layout.role-tab-items
        v-flex.xs3.lg2.scroll-y-overflow.elevation-1.my-1.roles-menu.align-self-start
          v-list.py-0
            v-list-tile.product-tile(
              v-for="product in Object.keys(computedRoles).sort((a, b) => a.localeCompare(b))"
              :key="product"
              :class="{ 'selected-product': currentProduct === product }"
              @click="currentProduct = product"
            )
              v-layout
                v-flex.xs10
                  |{{ product }}
                v-flex.xs2.text-xs-center
                  v-icon(dark small color="primary" v-if="object.referent_products && object.referent_products.includes(product)") record_voice_over
        v-flex.xs9.lg10.scroll-y-overflow.py-1.pl-4.roles-cb-wrap
          .elevation-2(style="min-height: 100%;")
            v-layout.align-baseline.wrap.px-5(v-if="currentProduct")
              v-flex.xs6.align-self-start(v-for="(status, role) in computedRoles[currentProduct].roles" :key="role")
                v-checkbox(
                  hide-details
                  :label="role"
                  color="primary"
                  @change="roleChange(computedRoles[currentProduct].roles[role], currentProduct, role)"
                  v-model="computedRoles[currentProduct].roles[role].value"
                )
    v-flex.xs4.history-wrapper.pa-3.mt-4
      .title.pb-1 Historique des rôles
      rc-user-roles-history(:history="rolesHistory" ref="historyComponent" v-rc-loader="historyLoading" @scrollDown="getHistory()")
  v-layout.justify-center.pt-5.px-5.font-italic.text-xs-center.subheading.grey--text.text--darken-2(v-else-if="object.has_idp_user || type === 'client'")
    |Il n'y a pas encore de roles affectables.
  v-layout.justify-center.pt-5.px-5.font-italic.text-xs-center.subheading.grey--text.text--darken-2(v-else)
    |Le contact n'a pas encore d'accès STUDIO
    |, il est nécessaire d'en créer un avant de pouvoir lui affecter des rôles.
</template>

<script>
import RcUserRolesHistory from '@/components/RcUserRoles/RcUserRolesHistory.vue';
import axios from 'axios';
import apiRoleService from '@/services/api/common/roleService';

export default {
  components: {
    RcUserRolesHistory,
  },
  props: {
    useDestinationId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      rolesHistory: [],
      activeProduct: null,
      currentProduct: null,
      editing: false,
      productTab: 'tab-0',
      historyLoading: false,
      historyCount: null,
      loaded: false,
      type: 'contact',
      object: this.$store.state.app.focusedObject,
      computedRoles: {},
      affectable: [],
      affected: [],
    };
  },
  mounted() {
    this.type = this.$route.meta.type;
    if (this.object.has_idp_user || this.type === 'client') {
      Promise.all([
        this.getComputedRoles(),
        this.getHistory(),
      ]).then(() => {
        this.$emit('gotRoles', { affected: this.affected, affectable: this.affectable });
        this.currentProduct = Object.keys(this.computedRoles).sort((a, b) => a.localeCompare(b))[0] || null;
        this.loaded = true;
      });
    } else {
      this.loaded = true;
    }
  },
  methods: {
    async getComputedRoles() {
      await Promise.all([this.getAffectable(), this.getAffected()]);
      const userRolesIds = this.affected.map(it => it.tpl_id);
      const rolesByCategories = this.affectable
        .filter(it => it.category_name !== null)
        .reduce((result, it) => {
          const role = {
            value: userRolesIds.indexOf(it.tpl_id) !== -1,
            tpl_id: it.tpl_id,
          };
          if (!result[it.category_name]) {
            result[it.category_name] = { roles: { [it.display_name]: role } };
          } else {
            result[it.category_name].roles[it.display_name] = role;
          }
          return result;
        }, {});
      this.computedRoles = rolesByCategories;
    },
    async getAffectable() {
      switch (this.type) {
        case 'user':
          this.affectable = await apiRoleService.getAssignableToUser();
          break;
        case 'client':
          this.affectable = await apiRoleService.getAssignableToClient();
          break;
        default:
          this.affectable = await apiRoleService.getAssignableToContact(this.object.parent_id);
      }
    },
    async getAffected() {
      switch (this.type) {
        case 'user':
          this.affected = await apiRoleService.getAssignedToUser(this.object.id);
          break;
        case 'client':
          this.affected = await apiRoleService.getAssignedToClient(this.object.id);
          break;
        default:
          this.affected = await apiRoleService.getAssignedToContact(this.object.id);
      }
    },
    async getHistory(added = false) {
      if (added || (!this.historyCount || (this.historyCount + 50) > this.$refs.historyComponent?.size)) {
        this.historyLoading = true;
        let historyResponse;
        switch (this.type) {
          case 'user':
            historyResponse = await apiRoleService.getHistoryForUser(this.object.id, 0, this.$refs.historyComponent?.size || 50);
            break;
          case 'client':
            historyResponse = await apiRoleService.getHistoryForClient(this.object.id, 0, this.$refs.historyComponent?.size || 50);
            break;
          default:
            historyResponse = await apiRoleService.getHistoryForContact(this.object.id, 0, this.$refs.historyComponent?.size || 50);
        }
        this.rolesHistory = historyResponse.data;
        this.historyCount = historyResponse.metadata.count;
        this.historyLoading = false;
      }
    },
    updateActiveRole(activeProduct, role, status) {
      this.items[activeProduct][role] = status;
    },
    async roleChange(role, product, roleName) {
      switch (this.type) {
        case 'user':
          role.value ? await apiRoleService.addToUser(role.tpl_id, this.object.id) : await apiRoleService.deleteFromUser(role.tpl_id, this.object.id);
          break;
        case 'client':
          role.value ? await apiRoleService.addToClient(role.tpl_id, this.object.id) : await apiRoleService.deleteFromClient(role.tpl_id, this.object.id);
          break;
        default:
          role.value ? await apiRoleService.addToContact(role.tpl_id, this.object.id) : await apiRoleService.deleteFromContact(role.tpl_id, this.object.id);
      }
      this.getComputedRoles().then(() => { this.$emit('gotRoles', { affected: this.affected, affectable: this.affectable }); });
      this.getHistory(true);
    },
  },
};
</script>

<style lang="scss">
  .roles-wrapper {
    .roles-cb-wrap {
      border-right: 1px solid #efefef;
      height: 300px;
    }
    .roles-menu {
      border-left: 2px solid #efefef;
      height: 292px;
    }
    .product-tile {
      transition: none;
      border-bottom: 1px solid lightgrey;
    }
    .selected-product {
      background-color: var(--primary);
      color: white;
      i {
        color: white!important;
      }
      transition: none;
    }
    .referent-badge {
      position: absolute;
      background-color: var(--primary);
      border-radius: 50%;
      padding: 3px;
      right: 0px;
      top: 0px;
    }
    .role-tab-items {
      max-height: 300px;
    }
  }
  .history-wrapper {
    height: calc(100vh - (var(--main-navigation-height) + 24px + 48px + 400px));
    .load-wrapper.load-content {
      > *:not(.isPending) {
        opacity: 0.4;
      }
    }
  }
</style>
